import React, { useEffect } from 'react'
import { useMappedState, useDispatch } from 'redux-react-hook';
import { FetchBank } from '../../store/bank/actions';

const style = {
    height: 200,
    margin: 20,
    textAlign: 'left',
    display: 'inline-block'
};

const padding = {
    padding: 10
}

const mapState = state => ({
    bank: state.bank,
});

const BankComponent = () => {
  const dispatch = useDispatch();
  const { bank } = useMappedState(mapState);

  useEffect(() => {
    if(!bank.touched) dispatch(FetchBank());
  }, []);

  return (
      <div>
          <h2>Konto do opłat</h2>
          <div style={style}>
              <div style={padding}><strong>Nazwa operatora:</strong> {bank.nazwa}</div>
              <div style={padding}><strong>Numer konta:</strong> {bank.konto}</div>
          </div>
      </div>
  );
}

export default BankComponent;


// WEBPACK FOOTER //
// ./src/components/Bank/BankComponent.js